<style>
#modelingLegendModal .v--modal-box.v--modal {
  min-height: 250px !important;
  min-width: 400px !important;
  max-width: 450px !important;
  max-height: 300px !important;
}
</style>

<template>
  <Modal
    modalName="modelingLegendModal"
    title="Legenda"
    :buttons="[]"
  >

  </Modal>
</template>

<script>
import Modal from '../../../shared/Modal';

export default {
  components: {
    Modal
  },
  data: () => ({

  }),
  methods: {

  }

}
</script>


// WEBPACK FOOTER //
// src/components/viewer/modelWat/modals/ModelingLegend.vue